<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/165gaAZ/tc-custom/9781488092855.jpg?1708779379236" alt="This image is the cover for the book In the Bodyguard's Arms, Bachelor Bodyguards"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the Bodyguard's Arms, Bachelor Bodyguards
      </h1>
      <p class="bookDescription body article font2">
        <b>From the <i>USA Today</i>–bestselling author. “Strong pacing, heightened tension and a calculating villain make this romance an intriguing and exciting one to read.” —<i>RT Book Reviews</i></b><br/><br/><i>How close is too close for a bachelor bodyguard and his alluring client?</i><br/><br/>As a supermodel, Teddie Plummer is used to being wanted. But a stalker? That’s terrifying new territory, so Teddie hires a professional to guard her. The moment she and Payne Protection Agency bodyguard Jordan “Manny” Mannes collide, searing attraction introduces a different brand of danger.<br/><br/>Former Marine Manny knows his boundaries. He’ll put his life on the line for Teddie, but won’t risk his career on a client—no matter how unbelievably sexy she is. The rules blur once Teddie ends up in his arms. He won’t hesitate to face hell itself to defend her, but will he be willing to let her walk away?<br/><br/><b>Praise for the novels of Lisa Childs</b><br/><br/>“Atmospheric, emotional, and well-told.” —Lori Wilde, <i>New York Times</i>–bestselling author<br/><br/>“Grabs you from page one . . . Lisa Childs paints an eerie, haunting suspense that will keep you riveted until the very last page!” —Rita Herron, <i>USA Today</i>–bestselling author<br/><br/>“Childs knows how to keep readers riveted.” —<i>RT Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Childs
      </h2>
      
      <p class="authorDescription body article">Ever since Lisa Childs read her first romance novel (a Harlequin of course) at age eleven, all she ever wanted to be was a romance writer. &#160;Now an award winning, best-selling author of nearly fifty novels for Harlequin, Lisa is living the dream. Lisa loves to hear from readers who can contact her on Facebook, through her website www.lisachilds.com or snail mail address PO Box 139, Marne, MI 49435.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0bb95490